module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('heading', {
    attrs: {
      "text": _vm.$t('gigs.title'),
      "level": 2,
      "font": "oswald",
      "color": "silver"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('gigs.what')))]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.gig.title))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('gigs.where')))]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.gig.place))])]), _vm._v(" "), (_vm.gig.date) ? _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('gigs.when')))]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.$d(new Date(_vm.gig.date), 'long')))])]) : _vm._e(), _vm._v(" "), (_vm.gig.bands) ? _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('gigs.who')))]), _vm._v(" "), _c('ul', {
    staticClass: "light"
  }, _vm._l((_vm.gig.bands), function(band) {
    return _c('li', [_vm._v(_vm._s(band.band) + " "), (band.style) ? _c('span', [_vm._v("(" + _vm._s(band.style) + ")")]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.gig.price) ? _c('div', [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('gigs.price')))]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.gig.price))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ca7308c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Gig.vue
// module id = 277
// module chunks = 0